import { Icon, IconProps } from "@chakra-ui/react";

export function CredtoLogo({ ...rest }: IconProps) {
  return (
    <Icon
      width="100%"
      height="auto"
      viewBox="0 0 508 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M452.3 105.5C434.9 100.8 422.6 87.6998 419.7 70.5998C417.5 57.5998 422 43.8998 431.5 34.2998C436.9 28.9998 446 23.7998 452 22.4998C453.9 22.1998 456.3 21.5998 457.3 21.3998C458.8 20.8998 459 21.6998 459 28.1998V35.4998L454.3 37.1998C447.8 39.4998 443 43.6998 439.5 50.0998C437 54.5998 436.5 56.5998 436.5 62.4998C436.5 68.3998 437 70.3998 439.5 74.8998C443 81.2998 447.8 85.4998 454.3 87.7998L459 89.4998V98.1998C459 103.1 458.7 107 458.3 106.9C457.8 106.9 455.1 106.2 452.3 105.5Z"
        fill="#0D0D0D"
      />
      <path
        d="M468 97.9998C468 90.5998 468.3 88.9998 469.5 88.9998C472.7 88.9998 480.9 83.9998 484.3 79.8998C495.7 66.5998 491.7 46.3998 475.9 38.4998C473.3 37.0998 470.4 35.9998 469.5 35.9998C468.3 35.9998 468 34.5998 468 28.3998V20.7998L471.3 21.4998C486.9 24.7998 498 33.2998 504.3 46.8998C507.2 52.9998 507.5 54.2998 507.5 63.9998C507.5 73.6998 507.2 74.9998 504.3 81.0998C497.9 94.6998 486.4 103.5 471.3 106.3L468 107V97.9998Z"
        fill="#0D0D0D"
      />
      <path
        d="M31.5002 104.7C16.0002 99.5 5.0002 87.7 1.4002 72.5L0.200195 67H8.9002H17.5002L19.2002 71.8C21.5002 78.2 25.7002 83 32.1002 86.5C36.8002 89.1 38.5002 89.5 45.0002 89.5C52.9002 89.5 57.6002 87.8 63.6002 82.7L66.5002 80.2L72.3002 85.5L78.0002 90.7L73.4002 94.9C70.9002 97.3 65.9002 100.6 62.2002 102.3C56.3002 105.1 54.3002 105.5 45.5002 105.7C39.2002 105.9 34.0002 105.5 31.5002 104.7Z"
        fill="#0D0D0D"
      />
      <path
        d="M92 63.5V21H115.3H138.5L144.5 23.8C151.9 27.3 156.4 32.3 158.5 39.2C160.6 46.3 160.4 56.5 158.1 61.5C156.4 65.4 148 74 146.1 74C145.6 74 145 75 144.8 76.2C144.6 77.8 147.5 82.5 154.7 92L164.8 105.5L156.2 105.8C150.2 106 147.3 105.7 146.4 104.8C145.7 104.1 141.3 97.9 136.6 91.1C128.1 78.7 128 78.6 128 72.4V66.2L132.5 65.6C142.8 64 148.5 50 142.3 41.6C138.3 36.2 134.3 35 120.6 35H108V70.5V106H100H92V63.5Z"
        fill="#0D0D0D"
      />
      <path
        d="M257 86V66H265.5H274V78.1V90.3L286.8 89.8C300.6 89.3 304.5 88.2 311 83C314.3 80.4 318.9 73 320.4 67.8C320.9 66.3 322.2 66 329.1 66H337.3L336.7 70.9C335.4 82.1 325 95.9 314 101.1C305.5 105.2 299.5 106 277.5 106H257V86Z"
        fill="#0D0D0D"
      />
      <path
        d="M178.5 63V21H209H239.5V28V35H216.7H193.9L194.2 44.2L194.5 53.5L213.8 53.8L233 54V61V68H213.5H193.9L194.2 79.8L194.5 91.5L217 92L239.5 92.5V98.8V105H209H178.5V63Z"
        fill="#0D0D0D"
      />
      <path d="M371 74V43H379H387V74V105H379H371V74Z" fill="#0D0D0D" />
      <path d="M242 61.5V58H249H256V61.5V65H249H242V61.5Z" fill="#0D0D0D" />
      <path
        d="M1.3998 54.3003C2.4998 48.0003 7.89981 38.2003 12.9998 33.0003C22.5998 23.5003 37.4998 18.6003 50.6998 20.8003C58.2998 22.1003 67.6998 26.4003 73.2998 31.2003L76.9998 34.5003L71.3998 39.4003L65.8998 44.2003L63.1998 41.7003C53.4998 32.4003 36.1998 32.7003 26.1998 42.3003C22.6998 45.6003 17.9998 53.8003 17.9998 56.5003C17.9998 57.7003 16.4998 58.0003 9.39981 58.0003H0.799805L1.3998 54.3003Z"
        fill="#0D0D0D"
      />
      <path
        d="M319.3 53.7C317.8 48.2 311.3 40.8 305.2 37.9C301.2 35.9 298.5 35.5 287.3 35.2L274 34.8V45.9V57H265.5H257V39V21H278.3C301.5 21 307.3 21.9 316.3 26.7C325.4 31.7 334.6 44.2 336.5 54.3L337.2 58H328.8H320.4L319.3 53.7Z"
        fill="#0D0D0D"
      />
      <path d="M343 28V21H379H415V28V35H379H343V28Z" fill="#0D0D0D" />
      <path d="M187 5.5V0H209H231V5.5V11H209H187V5.5Z" fill="#004DFF" />
    </Icon>
  );
}
